import { useState } from "react";
import { toast } from "@/components/ui/sonner";
import { api } from "@/lib/api";

export const useAdminCleanup = (onCleanupComplete) => {
  const [preview, setPreview] = useState(null);
  const [confirmation, setConfirmation] = useState("");
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");

  const loadPreview = async () => {
    setLoadingPreview(true);
    setError("");
    try {
      const response = await api.get("/admin/test-users/preview");
      setPreview(response.data);
      setConfirmation("");
    } catch (previewError) {
      setError(previewError.response?.data?.detail || "Unable to preview test users.");
    } finally {
      setLoadingPreview(false);
    }
  };

  const deleteTestUsers = async () => {
    setDeleting(true);
    setError("");
    try {
      const response = await api.post("/admin/test-users/delete", { confirmation });
      toast.success(`Deleted ${response.data.deleted_users} test users.`);
      setPreview(null);
      setConfirmation("");
      onCleanupComplete?.();
    } catch (deleteError) {
      const message = deleteError.response?.data?.detail || "Unable to delete test users.";
      setError(message);
      toast.error(message);
    } finally {
      setDeleting(false);
    }
  };

  return {
    confirmation,
    deleteTestUsers,
    deleting,
    error,
    loadPreview,
    loadingPreview,
    preview,
    setConfirmation,
  };
};